export default "__VITE_ASSET__nmaFFcdV__"